import script from "./AgentStepAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentStepAbout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { WizardSection }, script.__o.components);}